import React, { JSX, SetStateAction } from 'react'
import { useModal } from './hooks/useModal'
import classes from './Modal.module.sass'
import close from '../../../assets/images/icons/close.svg'
import { CommonModalPayload } from '../../types/interfaces'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  children: JSX.Element | JSX.Element[]
  modalActive: boolean
  yooKassa?: boolean
  setModalActive:
    | React.Dispatch<SetStateAction<boolean>>
    | ((state: boolean) => {
        payload: CommonModalPayload
        type: 'common-modal/setCommonModalState'
      })
  cantClose?: boolean
  image?: boolean
}

export const Modal = ({ modalActive, setModalActive, children, cantClose, image, yooKassa }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  useModal()
  if (modalActive)
    return (
      <div
        className={darkTheme ? classes.ModalWindowDark : classes.ModalWindow}
        onClick={() => {
          // !cantClose && setModalActive(false)
        }}
      >
        <div>
          {!cantClose && (
            <div className={classes.CloseAnchor}>
              <img
                className={classes.CloseIcon}
                src={close}
                alt="Закрыть"
                onClick={() => {
                  !cantClose && setModalActive(false)
                }}
              />
            </div>
          )}

          <div
            className={
              image
                ? classes.ModalContentContainerImage
                : darkTheme
                  ? classes.ModalContentContainerDark
                  : classes.ModalContentContainer
            }
            style={yooKassa ? { padding: 0 } : undefined}
            onClick={(e) => e.stopPropagation()}
          >
            {/* {!cantClose && !image && (
              <img
                className={classes.CloseIcon}
                src={close}
                alt="Закрыть"
                onClick={() => {
                  !cantClose && setModalActive(false)
                }}
              />
            )} */}

            {children}
          </div>
        </div>
      </div>
    )
  return <></>
}
